import { logger } from '@crx-dev/hss-react-infrastructure';
import React, { ReactNode, useEffect, useState } from 'react';
import { Setting } from '../../Areas/Settings/types/Setting';
import { fetchStoreSettings } from './Settings';

interface SettingsProviderProps {
    children: ReactNode;
}

interface ISettingsContext {
    storeSettings: Setting[];
    isLoaded: boolean;
    setIsLoaded: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SettingsContext = React.createContext<Partial<ISettingsContext>>({});

export default function SettingsProvider({ children }: SettingsProviderProps) {
    const [storeSettings, setStoreSettings] = useState<Setting[]>([]);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!isLoaded) {
            const settings = fetchStoreSettings();

            settings
                .then(s => {
                    setStoreSettings(s);
                    setIsLoaded(true);
                })
                .catch(e => logger.log('Error', `Settings: ${e}`));
        }
    }, [isLoaded]);

    const contextValue = {
        storeSettings: storeSettings,
        setIsLoaded: setIsLoaded,
        isLoaded: isLoaded
    };

    return <SettingsContext.Provider value={contextValue}>{children}</SettingsContext.Provider>;
}
